import { AnyUrlSearchParams } from './navigationUtils'

// Reference: https://www.geeksforgeeks.org/maximum-length-of-a-url-in-different-browsers/
export const MAX_URL_LENGTH = 2083

export enum BuilderSearchParam {
  LATITUDE = 'lat',
  LONGITUDE = 'lng',
  BEARING = 'bearing',
  PITCH = 'pitch',
  ZOOM = 'zoom',
  LAYERS = 'layers',
  SPATIAL_FILTER = 'mask',
  SEARCH = 'search'
}

export function queryParamToEnum<E>(value: string | null | undefined, defaultValue: E, enumDef?: Record<string, E>): E {
  if (value) {
    if (enumDef && !Object.values(enumDef).includes(value as unknown as E)) {
      return defaultValue
    }
    return value as unknown as E
  } else {
    return defaultValue
  }
}

export function queryParamToNumber(value: string | null, defaultValue = 0) {
  const x = value ? parseFloat(value) : NaN
  return isNaN(x) ? defaultValue : x
}

export function queryParamToBoolean(value: string | null) {
  return Boolean(value) && value !== '0' && value !== 'false'
}

const isUrlSearchParams = (params: AnyUrlSearchParams | URLSearchParams): params is URLSearchParams => {
  return params instanceof URLSearchParams
}

export function addQueryParamsRecursive(
  searchParams: URLSearchParams,
  params: AnyUrlSearchParams | URLSearchParams,
  prefix = ''
) {
  const entries = isUrlSearchParams(params) ? params.entries() : Object.entries(params)
  for (const [key, value] of entries) {
    if (typeof value === 'undefined' || value === null) continue

    if (typeof value === 'object') {
      addQueryParamsRecursive(searchParams, value as AnyUrlSearchParams, `${prefix}${key}.`)
    } else {
      searchParams.set(`${prefix}${key}`, String(value))
    }
  }
}

export function encodeUriParams(params: Record<string, unknown>) {
  return Object.entries(params)
    .map(([key, value]) => {
      if (value === undefined || value === null) {
        return value
      }

      const normalizedValue =
        typeof value === 'object' || Array.isArray(value) ? JSON.stringify(value) : (value as string)

      return `${key}=${encodeURIComponent(normalizedValue)}`
    })
    .filter(Boolean)
    .join('&')
}
